import Section from '~/components/common/Section';

function Description() {
    return (
        <Section title="Description">
            <p>
                We're a game studio from Vietnam on a wonderful journey with the mission of bringing a beautiful art
                form to everyone. The studio was founded by me, a solo developer behind the game{' '}
                <strong>The Ghost of Lake</strong>.
            </p>
        </Section>
    );
}

export default Description;
